import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
  Button,
  Input,
  Flex,
  useToast,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'

const schema = z.object({
  //só deixa registrar dateDe a partir do dia seguinte
  dateDe: z
    .string()
    .transform((val) => val.replace('T', ' '))
    .refine(
      (val) => {
        const date = new Date(val)
        const today = new Date()
        return date > today
      },
      {
        message: 'Data de deve ser a partir do dia seguinte',
      }
    ),

  //verifica se tem data, não pode ir vazio
  dateAte: z
    .string()
    .transform((val) => val.replace('T', ' '))
    .refine(
      (val) => {
        return val !== ''
      },
      {
        message: 'Data até é obrigatória',
      }
    ),
})

async function deactivatePeriod(params) {
  const response = await api.post('/site/v2/controle-rodizio/agendar-fila', params)

  return response.data
}

export function DesativarPeriodo({ vendedor }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: deactivatePeriod,
    onError: (error, variables, context) => {
      console.error(error)
      toast({
        title: 'Erro ao desativar vendedor',
        status: 'error',
      })
    },
    onSuccess: (data, variables, context) => {
      console.log(data)
      toast({
        title: 'Vendedor desativado com sucesso',
        status: 'success',
      })

      onClose()
      queryClient.invalidateQueries('controle-rodizio')
      reset()
    },
  })

  async function onSubmit(data) {
    const params = {
      codigo_usuario: vendedor.codigo_usuario,
      data_saida: data.dateDe,
      data_retorno: data.dateAte,
    }

    try {
      await mutateAsync(params)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <Button colorScheme="blue" size="sm" variant="ghost" onClick={onOpen}>
        Desativar por Período
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Desativar Vendedor por Período
            </AlertDialogHeader>

            <AlertDialogBody>
              Você tem certeza que deseja desativar o vendedor por um período?
              <Flex flexDir="column" gap={1} mt={4}>
                <label htmlFor="date-de">Data de:</label>
                <Input type="datetime-local" id="date-de" {...register('dateDe', { required: true })} />
                {errors.dateDe && (
                  <Text size="sm" color="red.500">
                    {errors.dateDe.message}
                  </Text>
                )}
              </Flex>
              <Flex flexDir="column" gap={1}>
                <label htmlFor="date-ate">Data até:</label>
                <Input type="datetime-local" id="date-ate" {...register('dateAte', { required: true })} />
                {errors.dateAte && (
                  <Text size="sm" color="red.500">
                    {errors.dateAte.message}
                  </Text>
                )}
              </Flex>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="green" ml={3} onClick={handleSubmit(onSubmit)} isLoading={isLoading}>
                Desativar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
